export default __webpack_public_path__ + "static/media/background_violet-small.4fd834fc.jpg";